import httpClient from './httpClient'

export default {
  async getClient() {
    let ret = await httpClient.get('/client')
    return ret
  },
  async saveClient(data) {
    let ret = await httpClient.post('/client', data)
    return ret
  },
  async removeClient(id) {
    let ret = await httpClient.delete('/client/' + id)
    return ret
  },
  async updateClient(id, data) {
    let ret = await httpClient.put('/client/' + id, data)
    return ret
  },
}
